import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Loader_Source_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_LOADERSOURCE_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Loader Source Id',       columnResourceName: 'colId',              alignment: HorizAlignment.Left},  domainOptions: {}},
    LOADERSOURCE_TYPE:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Source Type',        columnResourceName: 'colLSrcType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    LOADERSOURCE_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Source Id',          columnResourceName: 'colLSrcId',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_CONNECTION_ID:           {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Connection Id',          columnResourceName: 'colCnxId',           alignment: HorizAlignment.Left},  domainOptions: {}},
    CUSTOMER_LEVEL:             {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Customer Level',            columnResourceName: 'colCustLvl',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PRODUCT_LEVEL:              {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Product Level',             columnResourceName: 'colProdLvl',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_PERIODM_ID:              {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB PeriodM Id',             columnResourceName: 'colPeriodMId',       alignment: HorizAlignment.Left},  domainOptions: {}},
    PARTITION_FIELDNAME:        {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Partition Field Name',      columnResourceName: 'colPtFldName',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PARTITIONQUEUESIZE:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Partition Queue Size',      columnResourceName: 'colPtQueueSz',       alignment: HorizAlignment.Left},  domainOptions: {}}
};

const LoaderSourceSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_LOADERSOURCE_ID',
                id_ui: 'LOADERSOURCE_ID',
                name: 'LOADERSOURCE_ID'

    },

    searchProviderFields: vUI_Loader_Source_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Loader_Source_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const LoaderSourceSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "LoaderSourceSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'LOADERSOURCE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'LOADERSOURCE_ID', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'LOADERSOURCE_ID', 'LOADERSOURCE_TYPE', 'PARTITION_FIELDNAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: LoaderSourceSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const LoaderSourceSearch: ISearch = {
    searchName: "Find Loader Source",
    renderOptions: {ui5ResourceId: "LoaderSourceSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [LoaderSourceSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("LoaderSourceBO", "LoaderSource", LoaderSourceSearch, "Loader Source Search")

export {LoaderSourceSearch}